import { render, staticRenderFns } from "./ForgotPasswordSubmit.vue?vue&type=template&id=23f07881&scoped=true&"
import script from "./ForgotPasswordSubmit.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordSubmit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f07881",
  null
  
)

export default component.exports